module.exports = __webpack_public_path__ + "media/src/images/balloons/yellow_gradient-908c59a26cdfa9c122565ddb197c424b.jpg";